export enum AccordionRoutesEnum {
  SalespersonStep = "SalespersonStep",
  OccupationStep = "OccupationStep",
  ProductStep = "ProductStep",
  CircumstanceStep = "CircumstanceStep",
  InformationStep = "InformationStep",
  ConsentStep =  "ConsentStep",
  PaymentStep = "PaymentStep",
  ContactMeReciept = "ContactMeReciept",
  ContactMeStep = "ContactMeStep",
  ThankYouStep = "ThankYouStep",
  ProductStepV2 = "ProductStepV2",
  ProductStepIpad = "ProductStepIpad"
}
